export function priceSplit(price,index){
	let temp = price.toString().split('.');
	let arr = [
		temp[0],
		temp[1]?temp[1]:"00"
	];
	return arr[index||0];
}